export enum AppIcons {
    SG = 'schedule',
    CM = 'concessionManager',
    IC = 'income',
    BPN = 'deal',
    CH = 'chat',
    TU = 'sms',
    IN = 'addUser',
    UCM = 'concessionManager',
    USG = 'schedule',
    CBAI = 'chat',
    LC = 'chat',
}

export enum AppDisplayNames {
    SG = 'Schedule Genie',
    CM = 'Spotlight',
    IC = 'Income Calculator',
    BPN = 'Best Price Now',
    CH = 'Chat',
    TU = 'Text Us Now',
    IN = 'Insite',
    UCM = 'ULM Spotlight',
    USG = 'ULM Schedule Genie',
    CBAI = 'Claire AI+',
    LC = 'Live Chat',
}
